export default __webpack_public_path__ + "static/media/mixkit-paper-quick-movement-2380.3d934207.mp3";